export enum PessoaTelefoneTipo {
  CELULAR = 'CELULAR',
  COMERCIAL = 'COMERCIAL',
  FAX = 'FAX',
  OUTRO = 'OUTRO',
  RESIDENCIAL = 'RESIDENCIAL',
  TELEGRAM = 'TELEGRAM',
  WHATSAPP = 'WHATSAPP'
}
